var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 91,
    viewBox: "0 0 108 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#D11C1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_13727)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 88,
    height: 73,
    rx: 5,
    fill: "url(#paint0_linear_1_13727)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 18.5,
    width: 87,
    height: 72,
    rx: 4.5,
    stroke: "url(#paint1_linear_1_13727)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13727)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_13727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2419 50.9846C61.8941 50.9846 61.6129 50.7034 61.6129 50.3555C61.6129 45.8466 57.9444 42.1781 53.4355 42.1781C48.9266 42.1781 45.2581 45.8466 45.2581 50.3555C45.2581 50.7034 44.9769 50.9846 44.629 50.9846C44.2812 50.9846 44 50.7034 44 50.3555C44 45.1528 48.2328 40.92 53.4355 40.92C58.6382 40.92 62.871 45.1528 62.871 50.3555C62.871 50.7034 62.5898 50.9846 62.2419 50.9846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.629 73C44.2812 73 44 72.7188 44 72.3709V50.3548C44 50.0069 44.2812 49.7258 44.629 49.7258C44.9769 49.7258 45.2581 50.0069 45.2581 50.3548V72.3709C45.2581 72.7188 44.9769 73 44.629 73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2404 73C61.8925 73 61.6113 72.7188 61.6113 72.3709V50.3548C61.6113 50.0069 61.8925 49.7258 62.2404 49.7258C62.5882 49.7258 62.8694 50.0069 62.8694 50.3548V72.3709C62.8694 72.7188 62.5882 73 62.2404 73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2419 70.4838H44.629C44.2812 70.4838 44 70.2027 44 69.8548C44 69.5069 44.2812 69.2258 44.629 69.2258H62.2419C62.5898 69.2258 62.871 69.5069 62.871 69.8548C62.871 70.2027 62.5898 70.4838 62.2419 70.4838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2419 73.0003H44.629C44.2812 73.0003 44 72.7191 44 72.3713C44 72.0234 44.2812 71.7422 44.629 71.7422H62.2419C62.5898 71.7422 62.871 72.0234 62.871 72.3713C62.871 72.7191 62.5898 73.0003 62.2419 73.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3208 49.0992C54.9729 49.0992 54.6917 48.8181 54.6917 48.4702C54.6917 47.7758 54.1269 47.2109 53.4324 47.2109C52.738 47.2109 52.1731 47.7758 52.1731 48.4702C52.1731 48.8181 51.8919 49.0992 51.5441 49.0992C51.1962 49.0992 50.915 48.8181 50.915 48.4702C50.915 47.0819 52.0442 45.9528 53.4324 45.9528C54.8207 45.9528 55.9498 47.0819 55.9498 48.4702C55.9498 48.8181 55.6686 49.0992 55.3208 49.0992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4312 51.6142C52.0435 51.6142 50.915 50.4857 50.915 49.098C50.915 48.7502 51.1962 48.469 51.5441 48.469C51.8919 48.469 52.1731 48.7502 52.1731 49.098C52.1731 49.7918 52.7373 50.3561 53.4312 50.3561C54.125 50.3561 54.6892 49.7918 54.6892 49.098C54.6892 48.7502 54.9704 48.469 55.3183 48.469C55.6661 48.469 55.9473 48.7502 55.9473 49.098C55.9473 50.4857 54.8188 51.6142 53.4312 51.6142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5441 49.7266C51.1962 49.7266 50.915 49.4454 50.915 49.0975V48.4691C50.915 48.1213 51.1962 47.8401 51.5441 47.8401C51.8919 47.8401 52.1731 48.1213 52.1731 48.4691V49.0975C52.1731 49.4454 51.8919 49.7266 51.5441 49.7266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3187 49.7266C54.9709 49.7266 54.6897 49.4454 54.6897 49.0975V48.4691C54.6897 48.1213 54.9709 47.8401 55.3187 47.8401C55.6666 47.8401 55.9478 48.1213 55.9478 48.4691V49.0975C55.9478 49.4454 55.6666 49.7266 55.3187 49.7266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1742 52.8725C51.8263 52.8725 51.5452 52.5913 51.5452 52.2435V50.5023C51.5452 50.1545 51.8263 49.8733 52.1742 49.8733C52.5221 49.8733 52.8032 50.1545 52.8032 50.5023V52.2435C52.8032 52.5913 52.5221 52.8725 52.1742 52.8725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6906 52.8724C54.3427 52.8724 54.0615 52.5912 54.0615 52.2433V50.5034C54.0615 50.1556 54.3427 49.8744 54.6906 49.8744C55.0384 49.8744 55.3196 50.1556 55.3196 50.5034V52.2433C55.3196 52.5912 55.0384 52.8724 54.6906 52.8724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.837 54.1305C57.4892 54.1305 57.208 53.8493 57.208 53.5015C57.208 53.1543 56.9262 52.8724 56.579 52.8724C56.2311 52.8724 55.95 52.5913 55.95 52.2434C55.95 51.8956 56.2311 51.6144 56.579 51.6144C57.6194 51.6144 58.4661 52.4611 58.4661 53.5015C58.4661 53.8493 58.1849 54.1305 57.837 54.1305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5777 52.8724H54.6906C54.3427 52.8724 54.0615 52.5913 54.0615 52.2434C54.0615 51.8956 54.3427 51.6144 54.6906 51.6144H56.5777C56.9255 51.6144 57.2067 51.8956 57.2067 52.2434C57.2067 52.5913 56.9255 52.8724 56.5777 52.8724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8375 58.5338C57.4897 58.5338 57.2085 58.2526 57.2085 57.9048V53.5015C57.2085 53.1537 57.4897 52.8725 57.8375 52.8725C58.1854 52.8725 58.4666 53.1537 58.4666 53.5015V57.9048C58.4666 58.2526 58.1854 58.5338 57.8375 58.5338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.028 54.1305C48.6801 54.1305 48.3989 53.8493 48.3989 53.5015C48.3989 52.4611 49.2456 51.6144 50.286 51.6144C50.6339 51.6144 50.9151 51.8956 50.9151 52.2434C50.9151 52.5913 50.6339 52.8724 50.286 52.8724C49.9388 52.8724 49.657 53.1543 49.657 53.5015C49.657 53.8493 49.3758 54.1305 49.028 54.1305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1753 52.8724H50.2882C49.9404 52.8724 49.6592 52.5913 49.6592 52.2434C49.6592 51.8956 49.9404 51.6144 50.2882 51.6144H52.1753C52.5232 51.6144 52.8043 51.8956 52.8043 52.2434C52.8043 52.5913 52.5232 52.8724 52.1753 52.8724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.028 58.5338C48.6801 58.5338 48.3989 58.2526 48.3989 57.9048V53.5015C48.3989 53.1537 48.6801 52.8725 49.028 52.8725C49.3758 52.8725 49.657 53.1537 49.657 53.5015V57.9048C49.657 58.2526 49.3758 58.5338 49.028 58.5338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9166 67.3392C50.5688 67.3392 50.2876 67.058 50.2876 66.7102V55.3876C50.2876 55.0397 50.5688 54.7585 50.9166 54.7585C51.2645 54.7585 51.5457 55.0397 51.5457 55.3876V66.7102C51.5457 67.058 51.2645 67.3392 50.9166 67.3392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9489 67.3392C55.601 67.3392 55.3198 67.058 55.3198 66.7102V55.3876C55.3198 55.0397 55.601 54.7585 55.9489 54.7585C56.2967 54.7585 56.5779 55.0397 56.5779 55.3876V66.7102C56.5779 67.058 56.2967 67.3392 55.9489 67.3392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4327 67.3395C53.0849 67.3395 52.8037 67.0583 52.8037 66.7104V61.0491C52.8037 60.7013 53.0849 60.4201 53.4327 60.4201C53.7806 60.4201 54.0618 60.7013 54.0618 61.0491V66.7104C54.0618 67.0583 53.7806 67.3395 53.4327 67.3395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9151 60.4202C49.5274 60.4202 48.3989 59.2917 48.3989 57.9041C48.3989 57.5562 48.6801 57.275 49.028 57.275C49.3758 57.275 49.657 57.5562 49.657 57.9041C49.657 58.5979 50.2212 59.1621 50.9151 59.1621C51.2629 59.1621 51.5441 59.4433 51.5441 59.7912C51.5441 60.139 51.2629 60.4202 50.9151 60.4202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9489 60.4202C55.601 60.4202 55.3198 60.139 55.3198 59.7912C55.3198 59.4433 55.601 59.1621 55.9489 59.1621C56.6427 59.1621 57.2069 58.5979 57.2069 57.9041C57.2069 57.5562 57.4881 57.275 57.836 57.275C58.1838 57.275 58.465 57.5562 58.465 57.9041C58.465 59.2917 57.3365 60.4202 55.9489 60.4202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9489 67.3388H50.9166C50.5688 67.3388 50.2876 67.0576 50.2876 66.7098C50.2876 66.3619 50.5688 66.0807 50.9166 66.0807H55.9489C56.2967 66.0807 56.5779 66.3619 56.5779 66.7098C56.5779 67.0576 56.2967 67.3388 55.9489 67.3388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1451 71.1129C46.7973 71.1129 46.5161 70.8317 46.5161 70.4838V69.8548C46.5161 69.5069 46.7973 69.2258 47.1451 69.2258C47.493 69.2258 47.7742 69.5069 47.7742 69.8548V70.4838C47.7742 70.8317 47.493 71.1129 47.1451 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6615 71.1129C49.3136 71.1129 49.0325 70.8317 49.0325 70.4838V69.8548C49.0325 69.5069 49.3136 69.2258 49.6615 69.2258C50.0094 69.2258 50.2905 69.5069 50.2905 69.8548V70.4838C50.2905 70.8317 50.0094 71.1129 49.6615 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1776 71.1129C51.8298 71.1129 51.5486 70.8317 51.5486 70.4838V69.8548C51.5486 69.5069 51.8298 69.2258 52.1776 69.2258C52.5255 69.2258 52.8066 69.5069 52.8066 69.8548V70.4838C52.8066 70.8317 52.5255 71.1129 52.1776 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6937 71.1129C54.3459 71.1129 54.0647 70.8317 54.0647 70.4838V69.8548C54.0647 69.5069 54.3459 69.2258 54.6937 69.2258C55.0416 69.2258 55.3228 69.5069 55.3228 69.8548V70.4838C55.3228 70.8317 55.0416 71.1129 54.6937 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2101 71.1129C56.8622 71.1129 56.5811 70.8317 56.5811 70.4838V69.8548C56.5811 69.5069 56.8622 69.2258 57.2101 69.2258C57.5579 69.2258 57.8391 69.5069 57.8391 69.8548V70.4838C57.8391 70.8317 57.5579 71.1129 57.2101 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7242 71.1129C59.3764 71.1129 59.0952 70.8317 59.0952 70.4838V69.8548C59.0952 69.5069 59.3764 69.2258 59.7242 69.2258C60.0721 69.2258 60.3533 69.5069 60.3533 69.8548V70.4838C60.3533 70.8317 60.0721 71.1129 59.7242 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6286 50.9846C83.2808 50.9846 82.9996 50.7034 82.9996 50.3555C82.9996 45.8466 79.3311 42.1781 74.8222 42.1781C70.3133 42.1781 66.6448 45.8466 66.6448 50.3555C66.6448 50.7034 66.3636 50.9846 66.0158 50.9846C65.6679 50.9846 65.3867 50.7034 65.3867 50.3555C65.3867 45.1528 69.6195 40.92 74.8222 40.92C80.0249 40.92 84.2577 45.1528 84.2577 50.3555C84.2577 50.7034 83.9765 50.9846 83.6286 50.9846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0158 73C65.6679 73 65.3867 72.7188 65.3867 72.3709V50.3548C65.3867 50.0069 65.6679 49.7258 66.0158 49.7258C66.3636 49.7258 66.6448 50.0069 66.6448 50.3548V72.3709C66.6448 72.7188 66.3636 73 66.0158 73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6278 73C83.28 73 82.9988 72.7188 82.9988 72.3709V50.3548C82.9988 50.0069 83.28 49.7258 83.6278 49.7258C83.9757 49.7258 84.2568 50.0069 84.2568 50.3548V72.3709C84.2568 72.7188 83.9757 73 83.6278 73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6286 70.4838H66.0158C65.6679 70.4838 65.3867 70.2027 65.3867 69.8548C65.3867 69.5069 65.6679 69.2258 66.0158 69.2258H83.6286C83.9765 69.2258 84.2577 69.5069 84.2577 69.8548C84.2577 70.2027 83.9765 70.4838 83.6286 70.4838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6286 73.0003H66.0158C65.6679 73.0003 65.3867 72.7191 65.3867 72.3713C65.3867 72.0234 65.6679 71.7422 66.0158 71.7422H83.6286C83.9765 71.7422 84.2577 72.0234 84.2577 72.3713C84.2577 72.7191 83.9765 73.0003 83.6286 73.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.708 49.0992C76.3601 49.0992 76.079 48.8181 76.079 48.4702C76.079 47.7758 75.5141 47.2109 74.8196 47.2109C74.1252 47.2109 73.5603 47.7758 73.5603 48.4702C73.5603 48.8181 73.2791 49.0992 72.9313 49.0992C72.5834 49.0992 72.3022 48.8181 72.3022 48.4702C72.3022 47.0819 73.4314 45.9528 74.8196 45.9528C76.2079 45.9528 77.337 47.0819 77.337 48.4702C77.337 48.8181 77.0558 49.0992 76.708 49.0992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8208 51.6142C73.4332 51.6142 72.3047 50.4857 72.3047 49.098C72.3047 48.7502 72.5859 48.469 72.9337 48.469C73.2816 48.469 73.5628 48.7502 73.5628 49.098C73.5628 49.7918 74.127 50.3561 74.8208 50.3561C75.5146 50.3561 76.0789 49.7918 76.0789 49.098C76.0789 48.7502 76.3601 48.469 76.7079 48.469C77.0558 48.469 77.3369 48.7502 77.3369 49.098C77.3369 50.4857 76.2085 51.6142 74.8208 51.6142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9313 49.7266C72.5834 49.7266 72.3022 49.4454 72.3022 49.0975V48.4691C72.3022 48.1213 72.5834 47.8401 72.9313 47.8401C73.2791 47.8401 73.5603 48.1213 73.5603 48.4691V49.0975C73.5603 49.4454 73.2791 49.7266 72.9313 49.7266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7079 49.7266C76.36 49.7266 76.0789 49.4454 76.0789 49.0975V48.4691C76.0789 48.1213 76.36 47.8401 76.7079 47.8401C77.0557 47.8401 77.3369 48.1213 77.3369 48.4691V49.0975C77.3369 49.4454 77.0557 49.7266 76.7079 49.7266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5638 52.8725C73.216 52.8725 72.9348 52.5913 72.9348 52.2435V50.5023C72.9348 50.1545 73.216 49.8733 73.5638 49.8733C73.9117 49.8733 74.1929 50.1545 74.1929 50.5023V52.2435C74.1929 52.5913 73.9117 52.8725 73.5638 52.8725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0802 52.8724C75.7323 52.8724 75.4512 52.5912 75.4512 52.2433V50.5034C75.4512 50.1556 75.7323 49.8744 76.0802 49.8744C76.4281 49.8744 76.7092 50.1556 76.7092 50.5034V52.2433C76.7092 52.5912 76.4281 52.8724 76.0802 52.8724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2267 54.1305C78.8788 54.1305 78.5977 53.8493 78.5977 53.5015C78.5977 53.1543 78.3159 52.8724 77.9686 52.8724C77.6208 52.8724 77.3396 52.5913 77.3396 52.2434C77.3396 51.8956 77.6208 51.6144 77.9686 51.6144C79.0091 51.6144 79.8557 52.4611 79.8557 53.5015C79.8557 53.8493 79.5746 54.1305 79.2267 54.1305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9673 52.8724H76.0802C75.7323 52.8724 75.4512 52.5913 75.4512 52.2434C75.4512 51.8956 75.7323 51.6144 76.0802 51.6144H77.9673C78.3152 51.6144 78.5963 51.8956 78.5963 52.2434C78.5963 52.5913 78.3152 52.8724 77.9673 52.8724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2245 58.5338C78.8766 58.5338 78.5955 58.2526 78.5955 57.9048V53.5015C78.5955 53.1537 78.8766 52.8725 79.2245 52.8725C79.5723 52.8725 79.8535 53.1537 79.8535 53.5015V57.9048C79.8535 58.2526 79.5723 58.5338 79.2245 58.5338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4176 54.1305C70.0698 54.1305 69.7886 53.8493 69.7886 53.5015C69.7886 52.4611 70.6353 51.6144 71.6757 51.6144C72.0235 51.6144 72.3047 51.8956 72.3047 52.2434C72.3047 52.5913 72.0235 52.8724 71.6757 52.8724C71.3284 52.8724 71.0466 53.1543 71.0466 53.5015C71.0466 53.8493 70.7655 54.1305 70.4176 54.1305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5625 52.8724H71.6754C71.3276 52.8724 71.0464 52.5913 71.0464 52.2434C71.0464 51.8956 71.3276 51.6144 71.6754 51.6144H73.5625C73.9104 51.6144 74.1915 51.8956 74.1915 52.2434C74.1915 52.5913 73.9104 52.8724 73.5625 52.8724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4176 58.5338C70.0698 58.5338 69.7886 58.2526 69.7886 57.9048V53.5015C69.7886 53.1537 70.0698 52.8725 70.4176 52.8725C70.7655 52.8725 71.0466 53.1537 71.0466 53.5015V57.9048C71.0466 58.2526 70.7655 58.5338 70.4176 58.5338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3063 67.3392C71.9584 67.3392 71.6772 67.058 71.6772 66.7102V55.3876C71.6772 55.0397 71.9584 54.7585 72.3063 54.7585C72.6541 54.7585 72.9353 55.0397 72.9353 55.3876V66.7102C72.9353 67.058 72.6541 67.3392 72.3063 67.3392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3385 67.3392C76.9907 67.3392 76.7095 67.058 76.7095 66.7102V55.3876C76.7095 55.0397 76.9907 54.7585 77.3385 54.7585C77.6864 54.7585 77.9675 55.0397 77.9675 55.3876V66.7102C77.9675 67.058 77.6864 67.3392 77.3385 67.3392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8224 67.3395C74.4745 67.3395 74.1934 67.0583 74.1934 66.7104V61.0491C74.1934 60.7013 74.4745 60.4201 74.8224 60.4201C75.1702 60.4201 75.4514 60.7013 75.4514 61.0491V66.7104C75.4514 67.0583 75.1702 67.3395 74.8224 67.3395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3047 60.4202C70.9171 60.4202 69.7886 59.2917 69.7886 57.9041C69.7886 57.5562 70.0698 57.275 70.4176 57.275C70.7655 57.275 71.0466 57.5562 71.0466 57.9041C71.0466 58.5979 71.6109 59.1621 72.3047 59.1621C72.6526 59.1621 72.9337 59.4433 72.9337 59.7912C72.9337 60.139 72.6526 60.4202 72.3047 60.4202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3385 60.4202C76.9907 60.4202 76.7095 60.139 76.7095 59.7912C76.7095 59.4433 76.9907 59.1621 77.3385 59.1621C78.0323 59.1621 78.5966 58.5979 78.5966 57.9041C78.5966 57.5562 78.8777 57.275 79.2256 57.275C79.5735 57.275 79.8546 57.5562 79.8546 57.9041C79.8546 59.2917 78.7261 60.4202 77.3385 60.4202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3385 67.3388H72.3063C71.9584 67.3388 71.6772 67.0576 71.6772 66.7098C71.6772 66.3619 71.9584 66.0807 72.3063 66.0807H77.3385C77.6864 66.0807 77.9676 66.3619 77.9676 66.7098C77.9676 67.0576 77.6864 67.3388 77.3385 67.3388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5299 71.1129C68.1821 71.1129 67.9009 70.8317 67.9009 70.4838V69.8548C67.9009 69.5069 68.1821 69.2258 68.5299 69.2258C68.8778 69.2258 69.1589 69.5069 69.1589 69.8548V70.4838C69.1589 70.8317 68.8778 71.1129 68.5299 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0463 71.1129C70.6984 71.1129 70.4172 70.8317 70.4172 70.4838V69.8548C70.4172 69.5069 70.6984 69.2258 71.0463 69.2258C71.3941 69.2258 71.6753 69.5069 71.6753 69.8548V70.4838C71.6753 70.8317 71.3941 71.1129 71.0463 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5648 71.1129C73.217 71.1129 72.9358 70.8317 72.9358 70.4838V69.8548C72.9358 69.5069 73.217 69.2258 73.5648 69.2258C73.9127 69.2258 74.1939 69.5069 74.1939 69.8548V70.4838C74.1939 70.8317 73.9127 71.1129 73.5648 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0812 71.1129C75.7333 71.1129 75.4521 70.8317 75.4521 70.4838V69.8548C75.4521 69.5069 75.7333 69.2258 76.0812 69.2258C76.429 69.2258 76.7102 69.5069 76.7102 69.8548V70.4838C76.7102 70.8317 76.429 71.1129 76.0812 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5973 71.1129C78.2494 71.1129 77.9683 70.8317 77.9683 70.4838V69.8548C77.9683 69.5069 78.2494 69.2258 78.5973 69.2258C78.9451 69.2258 79.2263 69.5069 79.2263 69.8548V70.4838C79.2263 70.8317 78.9451 71.1129 78.5973 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1134 71.1129C80.7656 71.1129 80.4844 70.8317 80.4844 70.4838V69.8548C80.4844 69.5069 80.7656 69.2258 81.1134 69.2258C81.4613 69.2258 81.7424 69.5069 81.7424 69.8548V70.4838C81.7424 70.8317 81.4613 71.1129 81.1134 71.1129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.434 42.1777C53.0861 42.1777 52.8049 41.8965 52.8049 41.5487V39.0325C52.8049 38.6847 53.0861 38.4035 53.434 38.4035C53.7818 38.4035 54.063 38.6847 54.063 39.0325V41.5487C54.063 41.8965 53.7818 42.1777 53.434 42.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.434 39.6602C53.0861 39.6602 52.8049 39.3791 52.8049 39.0312C52.8049 37.297 54.2159 35.886 55.9501 35.886C56.2979 35.886 56.5791 36.1672 56.5791 36.5151C56.5791 36.8629 56.2979 37.1441 55.9501 37.1441C54.9097 37.1441 54.063 37.9908 54.063 39.0312C54.063 39.3791 53.7818 39.6602 53.434 39.6602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8224 42.1777C74.4745 42.1777 74.1934 41.8965 74.1934 41.5487V39.0325C74.1934 38.6847 74.4745 38.4035 74.8224 38.4035C75.1702 38.4035 75.4514 38.6847 75.4514 39.0325V41.5487C75.4514 41.8965 75.1702 42.1777 74.8224 42.1777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8224 39.6602C74.4746 39.6602 74.1934 39.3791 74.1934 39.0312C74.1934 37.9908 73.3467 37.1441 72.3063 37.1441C71.9584 37.1441 71.6772 36.8629 71.6772 36.5151C71.6772 36.1672 71.9584 35.886 72.3063 35.886C74.0405 35.886 75.4514 37.297 75.4514 39.0312C75.4514 39.3791 75.1703 39.6602 74.8224 39.6602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2388 37.1452C61.8909 37.1452 61.6098 36.864 61.6098 36.5161C61.6098 35.8223 61.0455 35.2581 60.3517 35.2581C60.0038 35.2581 59.7227 34.9769 59.7227 34.629C59.7227 34.2812 60.0038 34 60.3517 34C61.7393 34 62.8678 35.1285 62.8678 36.5161C62.8678 36.864 62.5866 37.1452 62.2388 37.1452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0143 37.1452C65.6664 37.1452 65.3853 36.864 65.3853 36.5161C65.3853 35.1285 66.5137 34 67.9014 34C68.2492 34 68.5304 34.2812 68.5304 34.629C68.5304 34.9769 68.2492 35.2581 67.9014 35.2581C67.2076 35.2581 66.6433 35.8223 66.6433 36.5161C66.6433 36.864 66.3621 37.1452 66.0143 37.1452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1263 39.0312C63.7785 39.0312 63.4973 38.75 63.4973 38.4022C63.4973 38.0543 63.7785 37.7731 64.1263 37.7731C64.8202 37.7731 65.3844 37.2089 65.3844 36.5151C65.3844 36.1672 65.6656 35.886 66.0134 35.886C66.3613 35.886 66.6425 36.1672 66.6425 36.5151C66.6425 37.9027 65.514 39.0312 64.1263 39.0312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1275 39.0312C62.7398 39.0312 61.6113 37.9027 61.6113 36.5151C61.6113 36.1672 61.8925 35.886 62.2404 35.886C62.5882 35.886 62.8694 36.1672 62.8694 36.5151C62.8694 37.2089 63.4336 37.7731 64.1275 37.7731C64.4753 37.7731 64.7565 38.0543 64.7565 38.4022C64.7565 38.75 64.4753 39.0312 64.1275 39.0312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3517 39.0312C60.0038 39.0312 59.7227 38.75 59.7227 38.4022C59.7227 38.0543 60.0038 37.7731 60.3517 37.7731C61.0455 37.7731 61.6098 37.2089 61.6098 36.5151C61.6098 36.1672 61.8909 35.886 62.2388 35.886C62.5866 35.886 62.8678 36.1672 62.8678 36.5151C62.8678 37.9027 61.7393 39.0312 60.3517 39.0312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9014 39.0312C66.5137 39.0312 65.3853 37.9027 65.3853 36.5151C65.3853 36.1672 65.6664 35.886 66.0143 35.886C66.3621 35.886 66.6433 36.1672 66.6433 36.5151C66.6433 37.2089 67.2076 37.7731 67.9014 37.7731C68.2492 37.7731 68.5304 38.0543 68.5304 38.4022C68.5304 38.75 68.2492 39.0312 67.9014 39.0312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0132 37.1452C65.6653 37.1452 65.3842 36.864 65.3842 36.5161C65.3842 35.8223 64.8199 35.2581 64.1261 35.2581C63.7782 35.2581 63.4971 34.9769 63.4971 34.629C63.4971 34.2812 63.7782 34 64.1261 34C65.5137 34 66.6422 35.1285 66.6422 36.5161C66.6422 36.864 66.3611 37.1452 66.0132 37.1452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2404 37.1452C61.8925 37.1452 61.6113 36.864 61.6113 36.5161C61.6113 35.1285 62.7398 34 64.1275 34C64.4753 34 64.7565 34.2812 64.7565 34.629C64.7565 34.9769 64.4753 35.2581 64.1275 35.2581C63.4336 35.2581 62.8694 35.8223 62.8694 36.5161C62.8694 36.864 62.5882 37.1452 62.2404 37.1452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0979 37.1441H55.9528C55.6049 37.1441 55.3237 36.8629 55.3237 36.5151C55.3237 36.1672 55.6049 35.886 55.9528 35.886H59.0979C59.4458 35.886 59.727 36.1672 59.727 36.5151C59.727 36.8629 59.4458 37.1441 59.0979 37.1441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3072 37.1441H69.162C68.8141 37.1441 68.533 36.8629 68.533 36.5151C68.533 36.1672 68.8141 35.886 69.162 35.886H72.3072C72.655 35.886 72.9362 36.1672 72.9362 36.5151C72.9362 36.8629 72.655 37.1441 72.3072 37.1441Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_13727",
    x: -5,
    y: -7,
    width: 138,
    height: 123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_13727"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_13727",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_13727",
    x: 40,
    y: 34,
    width: 48.2576,
    height: 47.0003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_13727"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_13727",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_13727",
    x1: -9.17563,
    y1: -51.6818,
    x2: 61.8865,
    y2: -38.3225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBFB",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_13727",
    x1: 106.029,
    y1: 67.5515,
    x2: 40.0421,
    y2: 62.8705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(42 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone1);
export default __webpack_public_path__ + "static/media/clone1.69350ff4eb3e6700056136d41e2561ca.svg";
export { ForwardRef as ReactComponent };